import React from 'react';

const AboutPage = () => (
  <div className="page-content">
    <p>I have strong Process/Chemical Engineering background and I have made a shift towards becoming a developer to further suit my interests. I love to build / design / create / invent / draw and I take pride in my work. I have no issues with learning new languages/frameworks as I have decent algorithms/pseudo-codes in my head which is the foundation to a good code. I like conflicts/challenges and I take mistakes positively as I believe these are fundamentals for mutual growth and success.</p>
	</div>
);

export default AboutPage;
